
var init = function(){
    // navSticky();
    // navbottomMobile();
    loaderMask();
    burgerClick();
    aosAnimate();
    setLazyload();
    bannerSwiper();
    matchHeight();
    photoPup();
    goTop();
    // navScroll();
    masonryLazy();
    workMasonry();
    currentYear();
}

// var navSticky = function(){
//     var navBottom = $('.nav_bottom');
//     var num = navBottom.offset().top;
//     $(window).on('scroll', function(){
//         if($(window).scrollTop() >= num){
//             navBottom.addClass('sticky');
//         }
//         else{
//             navBottom.removeClass('sticky');
//         }
//     })
// }

// var navbottomMobile = function(){
//     var arrow = $('.nav_bottom .arrow_box .image');
//     arrow.on('click', function(){
//         $(this).toggleClass('none_transform');
//         $('.mobile_guide_list_box').toggleClass('block');
//     })
// }

var loaderMask = function(){
    $(window).on('load', function(){
        $('.loader-mask').fadeOut();
    })
}

var burgerClick = function(){
    $('.burger').on('click', function(){
       
        $(this).toggleClass('click');
        $('.burger .item:nth-child(1)').toggleClass('line1');
        $('.burger .item:nth-child(2)').toggleClass('line2');
        $('.burger .item:nth-child(3)').toggleClass('line3');

        $('.body_content').toggleClass('hidden');

        $('.nav').toggleClass('mobile_mode');

        $('.mobile_nav').toggleClass('show');
        $('.mobile_nav .mobile_list').toggleClass('show');
    });
}

var aosAnimate = function(){
    AOS.init({
        duration: '600',
        easing: 'ease-out-quart'
    }); 

    // $(window).on('load', function(){
    //     AOS.init({
    //         duration: '600',
    //         easing: 'ease-out-quart'
    //     }); 
    // })

    // $(window).on('scroll', function(){
    //     var scrollRef = 0;
    //     scrollRef <= 10 ? scrollRef++ : AOS.refresh();
    // });
    // AOS.refresh();
}

var setLazyload = function(){
    // var lazyLoadInstance = new LazyLoad({
    //     elements_selector: ".lazy",
    // });
    $('.lazy').lazyload();
}

var bannerSwiper = function(){
    var banner = new Swiper('.swiper-container', {
        slidesPerView: 1,
        direction: 'horizontal',
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
        lazy: true,  
        speed: 500,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    })
}

var photoPup = function(){
    $('.work_content .grid-item .link').magnificPopup({
        type: 'image',
        mainClass: 'mfp-with-zoom',
        gallery: {
			enabled: true
        },
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it
            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function
            // opener: function (openerElement) {
            // return openerElement.is('img') ? openerElement : openerElement.find('img');
            // }
        }
    });
}

var matchHeight = function(){
    $(".service_box .list_box .list").matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });
}

var goTop = function(){
    $(window).on('scroll', function(){
        if($(window).scrollTop() > 400){
            $('.gotop').fadeIn();
        }
        else{
            $('.gotop').fadeOut();
        }

        $('.gotop').off('click');
        $('.gotop').on('click', function(){
            $('body, html').animate({
                scrollTop: 0
            }, 700)
            
        });
    });
}

var navScroll = function(){
    // var prevOffset = window.pageYOffset;
    // $(window).on('scroll', function(){
    //     var currentOffset = window.pageYOffset;
    //     if(currentOffset > prevOffset){
    //         if($(window).width() < 991){
    //             $('.nav').css('top', -60)
    //         }
    //         else{
    //             $('.nav').css('top', -100)
    //         }
    //     }
    //     else{
    //         $('.nav').css('top', 0)
    //     }
    //     prevOffset = currentOffset;
    // })
    // var lastScrollY = 0;
    // $(window).on('scroll', function(){
    //     var st = this.scrollY;
    //     if(window.pageYOffset < 0){
    //         $('.nav').css('top', 0)
    //     } 
    //     if( st > lastScrollY) {
    //         if($(window).width() < 991){
    //             $('.nav').css('top', -60)
    //         }
    //         else{
    //             $('.nav').css('top', -100)
    //         }
    //     }
    //     else {
    //         $('.nav').css('top', 0)
    //     }
    //     lastScrollY = st;
    // })
}

var masonryLazy = function(){
    $(".grid-item .link .image").lazyload({
        effect:"fadeIn",
        // failurelimit:40,
        load:workMasonry,
    });
}

var workMasonry = function(){
    var $grid = $('.grid');
    $grid.imagesLoaded(function(){
        $grid.masonry({
            itemSelector: '.grid-item',
        });
    });
}

var currentYear = function(){
    var year = new Date().getFullYear(); 
    $('#year').text(year);
}


init();